import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-areyousure',
    templateUrl: './areyousure.component.html',
    styleUrls: ['./areyousure.component.css']
})
export class AreyousureComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}  
}
